/** @format */

import React, { useEffect } from "react";
import { ArrowLeftIcon } from "@heroicons/react/outline";
import Footer from "../components/footer/Footer";
import Navbar from "../components/navbar/Navbar";

import { uid } from "uid";
import LoadingText from "../common/LoadingScreens/LoadingText";
import { getNews } from "../services/AnimeService";
import { toast } from "react-toastify";
import { SET_NEWS } from "../stateManagement/variables";
import { AppDataContext } from "../stateManagement/context/AppDataContext";
import ContentCardWide from "../common/contentCards/ContentCardWide";
import GoogleAd from "../ad/GoogleAd";
export default function NewsScreen(props) {
  const { appData, dispatch } = React.useContext(AppDataContext);
  const resolver = async () => {
    const res = await getNews();
    if (!res.data.length) {
      toast("No anime news found");
      return props.history.push("/");
    }
    dispatch({ type: SET_NEWS, payload: res.data });
  };

  useEffect(() => {
    resolver();
    //scrolling to top
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="dark:bg-gray-900">
      <Navbar />
      <br />
      <div className="min-h-screen w-full rounded-lg ">
        <div className="container shadow rounded-lg overflow-hidden m-auto mt-16">
          {/* Header */}
          <div className="flex  flex-row gap-5 px-3">
            <ArrowLeftIcon
              onClick={() => props.history.goBack()}
              className="w-8 cursor-pointer dark:text-white h-8 mt-1 "
            />
            <p className="dark:text-white text-4xl  font-montserrat font-thin ">
              Anime News
            </p>
          </div>

          <div className="mt-5 flex flex-wrap flex-row gap-5 py-5 p-2 ">
            {!appData.news.length ? (
              <RenderLoading />
            ) : (
              appData.news.map((data) => (
                <ContentCardWide key={uid()} data={data} />
              ))
            )}
          </div>
          <div className="mt-5">
            <GoogleAd slot="4222447002" />{" "}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

function RenderLoading() {
  return (
    <div className="mt-5  container flex flex-wrap flex-row gap-5 py-5 p-2 ">
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
    </div>
  );
}
